// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"00d41d5b","99":"6653249b","197":"9e2c724d","259":"e6850adf","381":"f4c5fe92","507":"0884a7e6","720":"da6590a2","754":"15e53288","967":"f3213d93","974":"45f1e9c1"}[chunkId] + ".chunk.css";
};